export enum Roles{
	CompanyRegistration="company/companyregistration",
	UserRegistration = "users/userregistration",
	GetCompanies = "company/findcompany",
    TeaEstateRegistration = "teaestate/teaestateregistration",
    GetTeaEstate = "teaestate/findteaestate"
}